import React from 'react';

import behaviorsIcon from 'src/public/img/undraw-dark-alley-hl-3-o.svg';
import physicalReactionsIcon from 'src/public/img/undraw-doctor-kw-5-l .svg';

import * as S from '../../stepComponents/styles';
import { CommonReactionsBox } from '../components/CommonReactionsBox';

const listBehaviors = [
    'Fighting with family',
    'Excessive substance abuse',
    'Being overprotective of family',
    'Keeping excessively busy',
    'Avoiding places, activities, or people that bring back memories',
    'Isolating',
    'Being very alert',
    'Startling easily',
];

const listPhysicalReactions = [
    'Fatigue',
    'Headache, tension, pain',
    'Increased heart rate',
    'Difficulty sleeping',
];

export const CommonReactionsSecondStep: React.SFC = () => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading>Common Reactions you Might Experience</S.StepHeading>
                <S.StepDescription small>
                    There are common emotional, mental, and behavioral reactions after someone
                    experiences or witnesses a traumatic event. These can be difficult but usually
                    improve over time.
                </S.StepDescription>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow type="flex">
            <CommonReactionsBox
                isHorizontal={false}
                title="Behaviors"
                icon={behaviorsIcon}
                list={listBehaviors}
            />
            <CommonReactionsBox
                isHorizontal={false}
                title="Physical Reactions"
                icon={physicalReactionsIcon}
                list={listPhysicalReactions}
            />
        </S.ContentRow>
    </>
);
